/* eslint-disable no-unused-vars */
/* eslint-disable react/self-closing-comp */
import React from "react";
import { Modal, ModalHeader, ModalFooter, Button, ModalBody } from "reactstrap";
import DataTable from "react-data-table-component";

function SubclientesModal({ handleIsOpenModal, handleToggleModal, data, novedades }) {
  const getNovedad = (tarea) => {
    return novedades && novedades.find((novedad) => novedad.id === tarea.novedadId);
  };
  return (
    <Modal centered backdrop="static" isOpen={handleIsOpenModal} toggle={handleToggleModal}>
      <div>
        <ModalHeader>Subclientes centralizados</ModalHeader>
        <ModalBody>
          <DataTable
            noDataComponent={
              <div className="p-3">
                <b>No se encontraron subclientes</b>
              </div>
            }
            striped
            data={data.flat()}
            columns={[
              {
                name: "Subcliente",
                // eslint-disable-next-line radix
                selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0),
                center: true,
                id: "subcliente",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Sucursal",
                // eslint-disable-next-line radix
                selector: (tarea) => getNovedad(tarea) && getNovedad(tarea).sucursal.titulo,
                center: true,
                id: "sucursal",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
            ]}
          ></DataTable>
        </ModalBody>
      </div>
      <ModalFooter>
        <Button type="submit" onClick={handleToggleModal}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SubclientesModal;
